































import { Component, Vue, Prop } from "vue-property-decorator";
@Component
export default class Oportunity extends Vue {
  @Prop({ default: "" })
  readonly id!: string;
  @Prop({ default: "" })
  readonly name!: string;
  @Prop({ default: "red-pastel" })
  readonly color!: string;
  @Prop({ default: "chart-card.png" })
  readonly icon!: string;
  @Prop({ default: true })
  readonly available!: boolean;

  getImgUrl(icon: string) {
    const images = require.context('../assets/icons/', false, /\.png$/);
    return images('./' + icon + '_80X90.png')
  }
}
